// src/app/shared/user-data.service.ts
import { Injectable } from '@angular/core';
import { IThreatAssessmentTeam } from '../../models/contact';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private buildingId: string | null = null;
  private regionId : string | null = null;
  private contactList: IThreatAssessmentTeam[] = [];
  private contact: IThreatAssessmentTeam | null = null; 

  setBuildingId(buildingId: string): void {
    this.buildingId = buildingId;
  }

  setRegionId(regionId: string): void {
    this.regionId = regionId;
  }

  setAssessUsersList(contactList: IThreatAssessmentTeam[]): void {
    this.contactList = contactList;
  }

  setCurrentUser(contact: IThreatAssessmentTeam): void {
    this.contact = contact;
  }

  getBuildingId(): string | null {
    // after a page reload, fall back to the building saved by the building route
    if (!this.buildingId && typeof localStorage !== 'undefined') {
      this.buildingId = localStorage.getItem("assess_building_id");
    }
    return this.buildingId;
  }
  
  getRegionId(): string | null {
    // after a page reload, fall back to the region saved by the building route
    if (!this.regionId && typeof localStorage !== 'undefined') {
      this.regionId = localStorage.getItem("assess_region_id");
    }
    return this.regionId;
  }

  getAssessUsersList(): IThreatAssessmentTeam[] {
    return this.contactList;
  }

  getCurrentUser(): IThreatAssessmentTeam | null {
    return this.contact;
  }
}
